/* @flow */

import React from 'react';
import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  // min-height: 500px;
  justify-content: center;
  min-height: ${({ height }) => height || 200}px;
  img {
    max-width: 104px;
    height: auto;
  }
  > p {
    font-size: 14px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-weight: 500;
    color: rgba(33, 40, 51, 1);
    line-height: 18px;
    margin-top: 20px;
  }
`;

type Props = {
  msg: string,
};

const NoData = ({ msg, img, height }: Props) => (
  <Content height={height}>
    <img src={img || '/static/images/common/norecord.svg'} alt={msg} />
    <p style={{color: '#76808F'}}>{msg}</p>
  </Content>
);

NoData.defaultProps = {
  msg: 'No Data!',
};

export default NoData;
